import { createSelector } from 'reselect';
import { getHashMap } from '../../lib/getHashMap.js';

const contactDetailTypes = (state) => state.app.contact_detail_types;

export const appDetailTypesSelector = createSelector(contactDetailTypes, (contactDetailTypes) => {
  return getHashMap(contactDetailTypes);
});
